// @flow

import React from 'react';

import extensionSettings from '@app/hocs/extension-settings';

import { T } from '@app/components/translation';
import { InfoBox } from '@app/components/info-box';
import DynamicLink from '@app/components/dynamic-link';

import style from './template-groups.module.scss';

// eslint-disable-next-line react/prefer-stateless-function
export class TemplateGroupsPage extends React.Component {
  render() {
    return (
      <div className={style.InfoBoxContainer}>
        <InfoBox
          bodyText={(
            <>
              <T
                _str="Configure the settings on the Workflows page under the Admin menu."
                _comment="Info box text in template groups page."
              />
              <span>{' '}</span>
              <DynamicLink
                url="/admin/workflows/template-groups"
                textClass={style.Link}
              >
                <T
                  _str="Go to page."
                  _comment="Link to template groups page."
                />
              </DynamicLink>
            </>
          )}
        />
      </div>
    );
  }
}

export default extensionSettings(TemplateGroupsPage);
